(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-redux"), require("aws-sdk/global"), require("amazon-cognito-identity-js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-redux", "aws-sdk/global", "amazon-cognito-identity-js"], factory);
	else if(typeof exports === 'object')
		exports["ReactCognito"] = factory(require("react"), require("react-redux"), require("aws-sdk/global"), require("amazon-cognito-identity-js"));
	else
		root["ReactCognito"] = factory(root["React"], root["ReactRedux"], root["aws-sdk/global"], root["AmazonCognitoIdentity"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition